import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import './Aboutme.css';
import ckanImage from '../../imgs/ckan-img3.png';

const SOCIALS = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/CKanMEX',
    icon: <path fill="currentColor" d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07C2 17.1 5.66 21.24 10.44 22v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.9h-2.34V22C18.34 21.24 22 17.1 22 12.07z"/>,
  },
  {
    label: 'Twitter / X',
    href: 'https://x.com/ckan98',
    icon: <path fill="currentColor" d="M3 3h4.6l4.16 6.18L16.76 3H21l-7.34 9.77L21.5 21h-4.6l-4.56-6.78L6.9 21H2l7.94-10.55L3 3z"/>,
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/ckan98',
    icon: <path fill="currentColor" d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5A5.5 5.5 0 1 1 6.5 13 5.5 5.5 0 0 1 12 7.5zm0 2A3.5 3.5 0 1 0 15.5 13 3.5 3.5 0 0 0 12 9.5zm5.75-3.25a1.25 1.25 0 1 1-1.25 1.25 1.25 1.25 0 0 1 1.25-1.25z"/>,
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCkD89TEFWsTZluY6tk84yqg',
    icon: <path fill="currentColor" d="M21.6 7.2a2.8 2.8 0 0 0-2-2C18 4.8 12 4.8 12 4.8s-6 0-7.6.4a2.8 2.8 0 0 0-2 2A29.6 29.6 0 0 0 2 12a29.6 29.6 0 0 0 .4 4.8 2.8 2.8 0 0 0 2 2C6 19.2 12 19.2 12 19.2s6 0 7.6-.4a2.8 2.8 0 0 0 2-2A29.6 29.6 0 0 0 22 12a29.6 29.6 0 0 0-.4-4.8zM10 15.2V8.8l6 3.2-6 3.2z"/>,
  },
];

const AboutMe = () => {
  const { t } = useT();

  const STATS = [
    { value: '2004', label: t('bioPage.statStart') },
    { value: '1B+',  label: t('bioPage.statStreams') },
    { value: '50+',  label: t('bioPage.statVideos') },
    { value: '30+',  label: t('bioPage.statCollabs') },
  ];

  return (
    <article className="bio-page">
      {/* ── Hero banner ── */}
      <div className="bio-hero">
        <img src={ckanImage} alt="C-Kan" className="bio-hero__img" />
        <div className="bio-hero__fade" />
        <div className="bio-hero__text">
          <p className="bio-hero__eyebrow">{t('bioPage.eyebrow')}</p>
          <h1 className="bio-hero__name">C-Kan</h1>
          <div className="bio-hero__socials">
            {SOCIALS.map(s => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="bio-social-icon"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">{s.icon}</svg>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* ── Stats bar ── */}
      <div className="bio-stats-bar">
        {STATS.map(s => (
          <div key={s.label} className="bio-stat-item">
            <span className="bio-stat-item__value">{s.value}</span>
            <span className="bio-stat-item__label">{s.label}</span>
          </div>
        ))}
      </div>

      {/* ── Body ── */}
      <div className="bio-body-wrap">
        <div className="bio-body">
          <p dangerouslySetInnerHTML={{ __html: t('bioPage.p1Html') }} />
          <p dangerouslySetInnerHTML={{ __html: t('bioPage.p2Html') }} />
          <p dangerouslySetInnerHTML={{ __html: t('bioPage.p3Html') }} />
          <p dangerouslySetInnerHTML={{ __html: t('bioPage.p4Html') }} />
        </div>
      </div>
    </article>
  );
};

export default AboutMe;
